import { authHeader,logout, handleResponse } from '../helpers';
import Vue from 'vue'

export const sifrantService = {
    load,save
    
};

function load(sifrant, sezona) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/sifrant/${sifrant}?sezona=${sezona}`, requestOptions)
        .then(handleResponse)
        //.then(sifrant => {
            // login successful if there's a jwt token in the response
            
          //  return sifrant;
        //});
}

function save(sifrant,item,sezona) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(item)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/sifrant/${sifrant}?sezona=${sezona}`, requestOptions).then(handleResponse);
}
